import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProductGroupDto } from '../../../../generated-model/models';
import { ProductCodeDto } from './product-code-service';
import { formatRecordedAt, resolveRecordedBy } from '../../../shared/commons/audit-display.util';

@Component({
  selector: 'app-product-code-modal',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './product-code-modal.html'
})
export class ProductCodeModal implements OnInit {
  @Input() item: ProductCodeDto | undefined;
  @Input() productGroups: ProductGroupDto[] = [];
  @Input() viewOnly = false;
  @Input() onSave?: (payload: any, isEditMode: boolean) => Promise<boolean>;

  form: FormGroup;
  isEditMode = false;
  submitted = false;
  isSubmitting = false;
  recordedByDisplay = '-';
  recordedAtDisplay = '-';

  constructor(public activeModal: NgbActiveModal, private fb: FormBuilder) {
    this.form = this.fb.group({
      id: [null],
      title: ['', [Validators.required, Validators.maxLength(255)]],
      productGroupId: [null, [Validators.required]],
      productCode: ['', [Validators.required, Validators.maxLength(11)]],
      fullName: [''],
      scienceName: [''],
      ordering: [0, [Validators.max(32767)]],
      state: [1]
    });
  }

  ngOnInit(): void {
    if (this.item) {
      this.isEditMode = true;
      this.form.patchValue(this.item);
      this.recordedByDisplay = resolveRecordedBy(this.item);
      this.recordedAtDisplay = formatRecordedAt(this.item);
    } else {
      this.form.reset({ ordering: 0, state: 1 });
      this.recordedByDisplay = '-';
      this.recordedAtDisplay = '-';
    }

    if (this.viewOnly) {
      this.form.disable();
    }
  }

  save(): void {
    if (this.viewOnly) {
      return;
    }
    this.submitted = true;
    if (this.form.invalid) {
      return;
    }
    void this.submitAndClose(this.form.value);
  }

  private async submitAndClose(payload: any): Promise<void> {
    if (!this.onSave) {
      this.activeModal.close(payload);
      return;
    }

    if (this.isSubmitting) {
      return;
    }

    this.isSubmitting = true;
    try {
      const isSuccess = await this.onSave(payload, this.isEditMode);
      if (isSuccess) {
        this.activeModal.close(payload);
      }
    } finally {
      this.isSubmitting = false;
    }
  }
}
